import Vue from 'vue';
import VuetifyxPlugin from "@vuetifyx/plugin";
import Vuetifyx from "@vuetifyx/vuetifyx"
import "@/assets/styles/yc-custom.scss"

Vue.use(VuetifyxPlugin)

Vue.prototype.$vuetifyx = Vuetifyx({
    defaultLayout: {
        attrs: {
            class: "yc-application"
        }
    },
    dialog: {
        content: {
            buttons: {
                cancel: {
                    attrs: {
                        text: true,
                        color: "",
                    }
                }
            },
            template: {
                button: {
                    attrs: {
                        color: "primary",
                        xClass: "ml-1",
                        text: false,
                    }
                }
            }
        }
    },
    dataTable: {
        content: {
            filterToolbar: {
                content: {
                    chipGroup: {
                        content: {
                            template: {
                                chip: {
                                    attrs: {}
                                }
                            }
                        }
                    },
                    template: {
                        inputDialog: {
                            content: {
                                buttons: {
                                    applyButton: {
                                        attrs: {
                                            color: ""
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            template: {
                topActionButton: {
                    attrs: {
                        color: "primary",
                        text: false,
                        small: false,
                        xClass: "yc-btn yc-btn-icon ml-1"
                    }
                },
                itemActionButton: {
                    type: "v-chip",
                    attrs: {
                        text: false,
                        outlined: true,
                        small: true,
                        xClass: "yc-app-status-action ml-1"
                    }
                }
            }
        }
    },
    defaultDataTable: {
        content: {
            template: {
                itemActionButtons: {
                    edit: {
                        attrs: {
                            color: "primary",
                        },
                        content: {
                            text: "Edit",
                            icon: ""
                        }
                    },
                    delete: {
                        attrs: {
                            color: "#d9303a",
                        },
                        content: {
                            text: "Delete",
                            icon: ""
                        }
                    }
                }
            }
        }
    }
})

